//import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import StarRateIcon from '@mui/icons-material/StarRate';
import { useTheme } from "@mui/material";


export default function TextCardStars({ textcheck }) {

    const theme = useTheme();
    
    let starCount = 0;

  if (textcheck.includes('criteria_provided,_multiple_submitters,_no_conflicts')) {
    starCount = 2;
  } else if (textcheck.includes('reviewed_by_expert_panel')) {
    starCount = 3;
  } else if (textcheck.includes('practice_guidelines')) {
    starCount = 4;
  }
   
    return (

        theme.palette.mode === "light" ? (
               

<div>
      
      <Stack direction="row" spacing={0.5}>
        {[...Array(starCount)].map((_, i) => (
          <StarRateIcon key={i} color="tertiary" />
        ))}
      </Stack>
    </div>

  ) : (

<div>
      
      <Stack direction="row" spacing={0.5}>
        {[...Array(starCount)].map((_, i) => (
          <StarRateIcon key={i} color="warning" />
        ))}
      </Stack>
    </div>
    )
)
}